import { useRef, useState, type ReactNode } from 'react';

/** Active projects as a horizontal snap carousel at ≤880px (mockup §2.1 B),
    with a mono dot row naming the card in view. The dots are a readout, not
    a control — the scroller is the control. */
export function ProjectCarousel({
  count,
  onHold,
  children,
}: {
  count: number;
  /** The "N on hold" link, which sits inline after the dots. */
  onHold?: ReactNode;
  children: ReactNode;
}) {
  const railRef = useRef<HTMLDivElement>(null);
  const [page, setPage] = useState(0);
  const onScroll = () => {
    const rail = railRef.current;
    if (!rail) return;
    const card = rail.firstElementChild as HTMLElement | null;
    const step = card ? card.offsetWidth + 12 : 248;
    setPage(Math.max(0, Math.min(count - 1, Math.round(rail.scrollLeft / step))));
  };
  return (
    <>
      <div className="pcar" ref={railRef} onScroll={onScroll}>
        {children}
      </div>
      {(count > 0 || onHold) && (
        <div className="pcar-foot">
          {count > 0 && (
            <span className="pcar-dots">
              {Array.from({ length: count }, (_, i) => (i === page ? '●' : '○')).join(' ')}
            </span>
          )}
          {count > 0 && onHold ? <span className="pcar-sep">·</span> : null}
          {onHold}
        </div>
      )}
    </>
  );
}
